import React from "react";
import { Check, Cloud, Mail, FileSpreadsheet, Code2 } from "lucide-react";

const ICONS = { cloud: Cloud, mail: Mail, "file-spreadsheet": FileSpreadsheet, "code-2": Code2 };

export default function ConnectStep({ sources, selected, onChange }) {
  const toggle = (id) => {
    onChange(selected.includes(id) ? selected.filter((s) => s !== id) : [...selected, id]);
  };
  return (
    <div>
      <h3 className="font-heading font-semibold text-white mb-1">Step 1 — Connect Data Sources</h3>
      <p className="text-sm text-slate-400 mb-4">Select the data sources you need to connect for this business scenario. Watch out — not every source is relevant!</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {sources.map((s) => {
          const Icon = ICONS[s.icon] || Cloud;
          const active = selected.includes(s.id);
          return (
            <button
              key={s.id} onClick={() => toggle(s.id)} data-testid={`connect-source-${s.id}`}
              className={`flex items-center gap-3 p-4 rounded-xl border text-left transition-colors ${
                active ? "border-indigo-400 bg-indigo-400/10" : "border-white/10 bg-white/[0.02] hover:border-white/25"
              }`}
            >
              <div className={`w-9 h-9 rounded-lg flex items-center justify-center shrink-0 ${active ? "bg-indigo-400/20 text-indigo-300" : "bg-white/5 text-slate-400"}`}>
                <Icon className="w-4.5 h-4.5" />
              </div>
              <div className="flex-1">
                <p className="text-sm font-medium text-white">{s.name}</p>
                <p className="text-[11px] text-slate-400">{s.fields.length} fields available</p>
              </div>
              {active && <Check className="w-4 h-4 text-indigo-400 shrink-0" />}
            </button>
          );
        })}
      </div>
    </div>
  );
}
